import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GridApi } from 'ag-grid-community';
import { VersionDetailsComponent } from '../version-details/version-details.component';
import { UmSummaryService } from 'src/app/services/um/um-summary.service';
import { EditAndDeleteOperationsRenderer } from 'src/app/common/client-grid/edit-and-delete-operations.component';
import { EditOthersRenderer } from 'src/app/common/client-grid/edit-others-operations.component';
import { CommonService } from 'src/app/services/common.service';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';

@Component({
  selector: 'app-version-history',
  templateUrl: './version-history.component.html',
  styleUrls: ['./version-history.component.scss']
})
export class VersionHistoryComponent implements OnInit {
  columnDefs;
  gridApi: GridApi;
  selectedRow;
  rowData: any;
  @Input() public Content: any;
  context: any;
  frameworkComponents: any;
  gridOptions: any;
  RequiredPolicyView:boolean = true;
  RequiredUploadIcon:boolean=true;
  Tempoperations: any[];
  operations: any[];
  constructor(public modalRef: NgbActiveModal, private modalService: NgbModal, private summaryService: UmSummaryService,private commonService :CommonService) {
  }
  ngOnInit() {
    //debugger;
    this.columnDefs = [
      {
        "headerName": "Version#",
        "field": "VerisonNo",
      }, {
        "headerName": "Date & Time",
        "field": "Datetime",
      },
      {
        "headerName": "Username",
        "field": "UserName",
      },
      {
        headerName: "Actions",
        field: "value",
        cellRenderer: "editOthersRenderer",
        colId: "params",
        sortable: false,
        cellStyle: { "overflow": 'visible' }
      }
    ]
    this.getVersionDetails();
    this.context = { componentParent: this };
    this.frameworkComponents = {
      editOthersRenderer: EditOthersRenderer
    };
    this.gridOptions = {
      pagination: true,
      rowSelection: 'single',
      rowHeight: 32,

      defaultColDef: {
        sortable: true,
        suppressNavigable: true,
        cellClass: 'no-border',
        suppressMovable: true,

      }
    }

    this.Tempoperations= [];
    this.Tempoperations.push({
      "name": "RequiredViewIcon",
      "id": "ViewIconClick"
      },{
      "name": "RequiredUploadIcon",
      "id": "UploadIconClick"
    });
    this.operations = this.Tempoperations.map(operation => {
      return (operation && (operation.id === 'add' || operation.id==='view_modal'))? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    });
  }

  getVersionDetails() {
    this.summaryService.getPolicyVersionhistory(this.Content.screencode).subscribe(summary => {
      this.rowData = summary.Data;
    });

  }

  onGridReady(params) {
    this.gridApi = params.api;
    setTimeout(() => {
      this.gridApi.sizeColumnsToFit();
      this.gridApi.startEditingCell(params);
    }, 500);
  }
  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onCallbackOperation(opr) {
    opr.callback();
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }
  UploadIconClick(data)
  {
      const modalRef = this['self'].modalService.open(DeleteBoxComponent,{backdrop: false})
        modalRef.componentInstance.Content={heading: 'Confirm', custommessage: 'Are you sure you want to set the workflow as latest?',ProceedButtonName:"Yes", TerminateButtonName:"No"}
        modalRef.result.then(result => {
        if(result=="okclick")
        {
          this['self'].summaryService.takeAsLatestPolicy(data.VersionID,this['self'].Content.screencode).subscribe(summary => {
            this['self'].commonService.SuccessBanner("Workflow status updated successfully");
               this['self'].modalRef.close();
          });
        }
      });
  }
  ViewIconClick(data)
  {
    //debugger;
    let modalRef = this['self'].modalService.open(VersionDetailsComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content = {
      VersionID:data.VersionID,
      screencode:this['self'].Content.screencode,
    }
    modalRef.result.then(result => {

    });
  }
  // vrsnDetails() {
  //   let modalRef = this.modalService.open(VersionDetailsComponent, {
  //     backdrop: false,
  //     keyboard: false,
  //     windowClass: 'modal-lg right modal-right',
  //     animation: true
  //   });
  //   modalRef.componentInstance.Content = {

  //   }
  // }

  onRowDoubleClicked($event)
  {

  }

}
